export const gnavItems = [
  'eyebrow',
  'tollfree',
  'contactus',
  'support',
  'store',
  'coveragemap',
  'L1',
  'unifiedCart',
  'wishList',
  'search',
  'promoRibbon',
];

export const FWA_CONSTANTS = {
  shaKey: 'TWoOwIsECMenIFOunDR97WMounTAIns8anD2A3DiaMOndYbUR15dCunderHN0rtHKELop',
};